/**
 * The "Farm" tag on traders (2026-10-20) stays hidden until Guillaume turns it on
 * (10-29: "Farm ticker should not be there yet"). The data (is_farm) is untouched.
 * Twin file: frontend/src/lib and mobile-app/src/lib must stay byte-identical.
 */
export const SHOW_FARM_TAG = false;
